import { createSelector } from 'reselect';

import { getCoworkingFixedWorkplaceSelector } from 'shared/store/coworking/selectors/dump/getCoworkingFixedWorkplaceSelector';

export const coworkingFixedWorkplaceWithErrorSelector = createSelector(getCoworkingFixedWorkplaceSelector, fixed => {
  if (fixed) {
    return fixed;
  }

  throw new Error('coworkingFixedWorkplaceWithErrorSelector Закреплённый офис не найден в сторе');
});
